import React, { useState } from "react";
import DialogContent from "@mui/material/DialogContent";
import { Button, Typography, AppBar, Toolbar, IconButton } from "@mui/material";
import CloseIcon from '@material-ui/icons/Close';
import { ContainerDialog, FormOverlay, ContainerLogin } from "./styled";
import FrmLogin from "./FrmLogin";
import FrmRegistro from "./FrmRegistro";


const FrmContenedor = ({ handleClose, fncPostula }) => {
  const [loginActive, setLoginActive] = useState(true);

  const RenderLoginOverlay = () => {
    return (
      <div className="overlay">
        <Typography variant="h1" className="title">Haz login y postúlate</Typography>
        <Typography variant="p" className="texto">Si ya tienes cuenta en Mi Reclu, postúlate con tu usuario y contraseña.</Typography>
        <Button className="btnInfo" onClick={() => setLoginActive(!loginActive)} variant="contained">Login</Button>
      </div>
    );
  };

  const RenderRegistroOverlay = () => {
    return (
      <div className="overlay">
        <Typography variant="h1" className="title">Registrate y postúlate</Typography>
        <Typography variant="p" className="texto">Si aún no tienes cuenta en Mi Reclu, crea una y postúlate a la vacante.</Typography>
        <Button className="btnInfo" onClick={() => setLoginActive(!loginActive)} variant="contained">Registro</Button>
      </div>
    );
  };

  return (
    <ContainerDialog
      open={true}
      fullWidth={true}
      maxWidth="lg"
      onClose={handleClose}
      id="modalPostulacion"
    >
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent>
        
          <FrmLogin
            active={loginActive}
            fncPostula={() => fncPostula()}
            fncMobile={() => setLoginActive(!loginActive)}
          />
          <FrmRegistro
            active={!loginActive}
            fncPostula={() => fncPostula()}
            fncMobile={() => setLoginActive(!loginActive)}
          />
          <FormOverlay isLogin={loginActive}>
            {loginActive ? RenderRegistroOverlay() : RenderLoginOverlay()}
          </FormOverlay>

      </DialogContent>
    </ContainerDialog>
  );
};
export default FrmContenedor;
